/**
 * WaveformGenerator Class
 * Static utility class for generating multi-resolution waveform data
 */
export class WaveformGenerator {
  /**
   * Generate waveform peak data at multiple resolutions
   * Updated to use only 1/100 and 1/1000 mipmap levels
   */
  static generateWaveformData(audioBuffer, resolutions = [100, 1000]) {
    const data = {};
    resolutions.forEach(resolution => {
      data[resolution] = this.calculatePeaks(audioBuffer, resolution);
    });
    return data;
  }

  static calculatePeaks(audioBuffer, samplesPerPeak) {
    const channelData = audioBuffer.getChannelData(0);
    const peaks = [];

    for (let i = 0; i < channelData.length; i += samplesPerPeak) {
      let min = 1.0;
      let max = -1.0;

      for (let j = 0; j < samplesPerPeak && i + j < channelData.length; j++) {
        const sample = channelData[i + j];
        if (sample < min) min = sample;
        if (sample > max) max = sample;
      }

      peaks.push({ min, max });
    }

    return peaks;
  }

  static selectWaveformResolution(pixelsPerSample, availableResolutions = [100, 1000]) {
    if (pixelsPerSample >= 1) {
      return availableResolutions[0];
    }

    const samplesPerPixel = 1 / pixelsPerSample;

    // Switch to higher resolution more aggressively (at 2x the threshold)
    // This ensures we get better detail earlier and avoid gaps when zooming in
    const aggressiveFactor = 2.0;

    for (let i = 0; i < availableResolutions.length; i++) {
      if (availableResolutions[i] * aggressiveFactor >= samplesPerPixel) {
        return availableResolutions[i];
      }
    }

    return availableResolutions[availableResolutions.length - 1];
  }
}
